import { BaseDto } from "../common/baseDto";
import { formatDate, toLocalDateTime } from "../../utils/string/stringUtil";


export interface ProductResultDto extends BaseDto {

	productResultNo: string;        // 생산실적번호
	compCd: string;                 // 사업장코드
	compNm: string;                 // 사업장명 (조인)
	productDt: string | undefined;  // 생산일자
	orderType: string;              // 지시구분
	workplaceCd: string;            // 작업장코드
	workplaceNm: string;            // 작업장명 (조인)
	jobTeam: string;                // 작업조
	itemCd: string;                 // 품목코드
	itemStatus: string;             // 품목상태
	itemNm: string;                 // 품명 (조인)
	itemSpec: string;               // 규격 (조인)
	itemUnit: string;               // 단위 (조인)
	productOrderNo: string;         // 생산지시번호
	orderQty: number;               // 지시수량
	productEmp: string;             // 작업자
	productEmpNm: string;           // 작업자명 (조인)
	workStartDt: string | undefined; // 작업시작시간
	workEndDt: string | undefined;   // 작업종료시간
	productQty: number;             // 생산수량
	badQty: number;                 // 불량수량
	acceptQty: number;              // 입고수량
	logicCenter: string;            // 입고물류
	warehouseCd: string;            // 입고창고
	warehouseNm: string;            // 입고창고명 (조인)
	basOrderType: string;           // 생산실적 내역의 구분
	basOrderNo: string;             // 생산실적 내역의 번호
	basOrderItemNo: string;         // 생산실적 내역의 항목번호
	kpiYn: string;                  // KPI 여부
	inspectQty: number;             // 품질검사 합격수량
	inspectYn: string;              // 품질검사 완료여부
	remark?: string;                // 비고

	inserted: boolean;
	isModified: boolean;
}

export const defaultProductResultDto: ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: 'Y',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',
	
	inserted: false,
	isModified: false,
}
